import React from 'react';
import { ModalSection } from '../ModalSections/ModalSection';
import { ModalSectionHeading } from '../ModalSections/ModalSectionHeading';
import { localise } from '../../../services/lang/lang';
import { ModalSectionOption } from '../ModalSections/ModalSectionOption';
import { ModalSectionOptionTitle } from '../ModalSections/ModalSectionOptionTitle';
import { ModalSectionOptionControl } from '../ModalSections/ModalSectionOptionControl';
import { PermissionGuard } from '../PermissionGuard/PermissionGuard';
import { RoleOption } from '../../../types/enums/Role';
import { ModalSectionContainer } from '../ModalSections/ModalSectionContainer';
export const PermissionModalContent = (props) => {
    const onStagedRoleChange = (role) => (event) => {
        if (event.target.checked) {
            props.onAddRole(role);
        }
        else {
            props.onRemoveRole(role);
        }
    };
    return (React.createElement(ModalSectionContainer, null,
        React.createElement(ModalSection, null,
            React.createElement(ModalSectionHeading, null, localise('STANDARD')),
            React.createElement(ModalSectionOption, null,
                React.createElement(ModalSectionOptionTitle, null, localise('INSPECTOR')),
                React.createElement(ModalSectionOptionControl, { isChecked: true, isDisabled: true }, localise('INSPECTOR_DESCRIPTION'))),
            React.createElement(PermissionGuard, { permissions: ['users.set-roles'], resource: [RoleOption.TeamManager.toString()] },
                React.createElement(ModalSectionOption, null,
                    React.createElement(ModalSectionOptionTitle, null, localise('TEAM_MANAGER')),
                    React.createElement(ModalSectionOptionControl, { onChange: onStagedRoleChange(RoleOption.TeamManager), isChecked: props.checkedRoles.includes(RoleOption.TeamManager), "data-testid": "permission-modal-content__team-manager-checkbox" }, localise('TEAM_MANAGER_DESCRIPTION'))))),
        React.createElement(PermissionGuard, { permissions: ['users.set-roles'], resource: [RoleOption.OrganisationManager.toString()] },
            React.createElement(ModalSection, null,
                React.createElement(ModalSectionHeading, null, localise('ADVANCED')),
                React.createElement(ModalSectionOption, null,
                    React.createElement(ModalSectionOptionTitle, null, localise('ORGANISATION_MANAGER')),
                    React.createElement(ModalSectionOptionControl, { onChange: onStagedRoleChange(RoleOption.OrganisationManager), isChecked: props.checkedRoles.includes(RoleOption.OrganisationManager) }, localise('ORGANISATION_MANAGER_DESCRIPTION')))))));
};
